import { UIEventBufferStorage } from '../UIEventBufferStorage';

/** Throws away everything waiting to be sent. */
export function clearUIEventBuffer(storage: UIEventBufferStorage): void {
  storage.clear();
}
